import React, {useState, useEffect, useContext} from 'react'
import { FirebaseContext } from '../../Services/firebase'

import { FormControl, TextField, Button, Autocomplete, InputLabel, MenuItem, Select, Dialog, DialogContent } from '@mui/material';
import { getWeeks } from '../../Utils/getWeeks';

import ChoicesTab from './ChoicesTab';
import { PDFViewer } from '@react-pdf/renderer';

export default function RecapChoices (props) {

    const firebase = useContext(FirebaseContext)

    const [Value, setValue] = useState('semaines');
    const [InputValue, setInputValue] = useState('');
    const [Weeks, setWeeks] = useState([]);
    const [Jour, setJour] = React.useState('');
    const [Exist, setExist] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [Choices, setChoices] = useState([]);
    const [Date, setDate] = useState('');
    const [Tour, setTour] = useState()  

    const getChoices = () => {
        firebase.getDayChoices(props.UserSession.uid, Value, Jour).get()
        .then( doc => {
            doc.docs.forEach(result => {
                firebase.getCustomerInfos(props.UserSession.uid, result.data().customer).get()
                .then( res => {
                    if (res.data().tourNum === Tour) {
                        setChoices(Choices => [...Choices, result.data()])
                        setDate(result.data().date)
                    }
                })
            })
        })
        setExist(true)
        setOpen(true);
    }

    const handleChange = (event) => {
      setJour(event.target.value);
    };

    useEffect(() => {
        getWeeks(firebase, props.UserSession.uid, setWeeks);
    }, [firebase, props.UserSession.uid]);

    const handleClose = () => {
        setOpen(false);
        setValue('semaines')
        setJour('')
        setChoices([])
        setTour()
    };

    const handleTour = (event) => {
        setTour(event.target.value);
    };

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, width: "100%"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Autocomplete
                    value={Value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={InputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Weeks}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="semaine"/>}
                />
                <FormControl sx={{ width: "12vw", marginTop: "20px" }}>
                    <InputLabel id="demo-simple-select-label">
                            Jour
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={Jour}
                        onChange={handleChange}
                        label="Jour"
                    >
                        <MenuItem value={1}>Lundi</MenuItem>
                        <MenuItem value={2}>Mardi</MenuItem>
                        <MenuItem value={3}>Mercredi</MenuItem>
                        <MenuItem value={4}>Jeudi</MenuItem>
                        <MenuItem value={5}>Vendredi</MenuItem>
                        <MenuItem value={6}>Samedi</MenuItem>
                        <MenuItem value={7}>Dimanche</MenuItem>
                    </Select>
                </FormControl>
                <FormControl sx={{ width: "12vw", marginTop: "20px" }}>
                    <InputLabel id="demo-simple-select-label">
                            Tournée
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={Tour}
                        label="Numéro de tournée"
                        onChange={handleTour}
                        >
                        <MenuItem value={'1'}>1</MenuItem>
                        <MenuItem value={'2'}>2</MenuItem>
                        <MenuItem value={'3'}>3</MenuItem>
                        <MenuItem value={'4'}>4</MenuItem>
                        <MenuItem value={'5'}>5</MenuItem>
                        <MenuItem value={'6'}>6</MenuItem>
                        <MenuItem value={'7'}>7</MenuItem>
                    </Select>
                </FormControl>
                
                <Button disabled={Value === 'semaines' || Jour === '' || Tour === ''} variant="contained" sx={{marginTop: "1vh", width: "8vw"}} onClick={getChoices}>Afficher</Button>
            </div>
            <div style={{display: "flex", flexDirection: "column", marginLeft: "2vw"}}>
                {
                    Exist === false ? null :
                    <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth={'lg'}
                    >
                        <DialogContent>
                            <PDFViewer style={{width: "90vw", height: "80vh"}}>
                                <ChoicesTab choices={Choices} date={Date}/>
                            </PDFViewer>
                        </DialogContent>
                    </Dialog>
                }
            </div>
        </div>
    )
}